import { connect } from "react-redux";
import PropTypes from "prop-types";
import BaggageInfo from "./BaggageInfo";
import {
	getFlightOptionsOfSelectedFlight,
	getCabinLuggageTotalPrice,
	getLuggageTotalPrice,
	getMaxLuggageCount,
	getCurrentLuggageOption,
	getSelectedTransportType,
} from "app/pages/Booking/bookingSelectors";
import { BAGGAGE_TYPES, OFFER_TYPES, TRANSPORTATION_TYPES } from "app/constants";
import { useIntl } from "react-intl";

const BaggageInfoContainer = ({
	handBaggageQuantity,
	handBaggageDetails,
	cabinBaggageDetails,
	isCabinBaggageIncluded,
	isHandBaggageIncluded,
	cabinBaggageQuantity,
	isCabinBaggageOffered,
	cabinBaggagePrice,
	isCheckedBaggageIncluded,
	isCheckedBaggageOffered,
	checkedBaggageQuantity,
	checkedBaggagePrice,
	checkedBaggageMaxWeight,
	isSelectedTransportTrain = false,
	offerType,
	...props
}) => {
	const { formatMessage } = useIntl();

	const checkedBaggageMaxWeightDetails =
		checkedBaggageMaxWeight > 0
			? formatMessage(
					{ id: "quotation.transport.luggage.option.max.weight" },
					{ weight: checkedBaggageMaxWeight }
			  )
			: null;

	if (offerType === OFFER_TYPES.ACCOMODATION_ONLY) {
		return null;
	}

	const baggageList = isSelectedTransportTrain
		? [
				{
					type: BAGGAGE_TYPES.TRAIN_BAGGAGE,
					quantity: checkedBaggageQuantity,
					included: isCheckedBaggageIncluded,
					offered: isCheckedBaggageOffered,
					price: checkedBaggagePrice,
					details: checkedBaggageMaxWeightDetails,
				},
		  ]
		: [
				{
					type: BAGGAGE_TYPES.HAND_BAGGAGE,
					quantity: isHandBaggageIncluded ? handBaggageQuantity : 0, // set quantity to 0 if not included to hide the hand baggage info
					included: isHandBaggageIncluded,
					details: handBaggageDetails,
				},
				{
					type: BAGGAGE_TYPES.CABIN_BAGGAGE,
					quantity: cabinBaggageQuantity,
					included: isCabinBaggageIncluded,
					offered: isCabinBaggageOffered,
					price: cabinBaggagePrice,
					details: cabinBaggageDetails,
				},
				{
					type: BAGGAGE_TYPES.CHECKED_BAGGAGE,
					quantity: checkedBaggageQuantity,
					included: isCheckedBaggageIncluded,
					offered: isCheckedBaggageOffered,
					price: checkedBaggagePrice,
					details: checkedBaggageMaxWeightDetails,
				},
		  ].filter(baggage => baggage.included || baggage.quantity > 0);

	return <BaggageInfo baggageList={baggageList} {...props} />;
};

BaggageInfoContainer.propTypes = {
	isHandBaggageIncluded: PropTypes.bool,
	handBaggageQuantity: PropTypes.number,
	handBaggageDetails: PropTypes.string,
	cabinBaggageDetails: PropTypes.string,
	isCabinBaggageIncluded: PropTypes.bool,
	cabinBaggageQuantity: PropTypes.number,
	isCabinBaggageOffered: PropTypes.bool,
	cabinBaggagePrice: PropTypes.number,
	isCheckedBaggageIncluded: PropTypes.bool,
	isCheckedBaggageOffered: PropTypes.bool,
	checkedBaggageQuantity: PropTypes.number,
	checkedBaggagePrice: PropTypes.number,
	checkedBaggageMaxWeight: PropTypes.number,
	offerType: PropTypes.oneOf(
		OFFER_TYPES.ACCOMODATION_ONLY,
		OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION
	),
	isSelectedTransportTrain: PropTypes.bool,
};

const mapStateToProps = state => {
	const isHandBaggageIncluded = getFlightOptionsOfSelectedFlight(state)?.flightBagageOption
		?.handBaggage?.included;

	const isCabinBaggageIncluded = getFlightOptionsOfSelectedFlight(state)?.flightBagageOption
		?.cabinBaggage?.included;

	return {
		offerType: state?.booking?.offer?.type,
		isHandBaggageIncluded,
		handBaggageQuantity: getMaxLuggageCount(state),
		handBaggageDetails: getFlightOptionsOfSelectedFlight(state)?.flightBagageOption?.handBaggage
			?.details,
		isCabinBaggageIncluded,
		cabinBaggageQuantity: isCabinBaggageIncluded
			? getMaxLuggageCount(state)
			: state?.booking?.cabinLuggage?.quantity,
		isCabinBaggageOffered:
			state?.booking?.cabinLuggage?.quantity > 0 && getCabinLuggageTotalPrice(state) === 0,
		cabinBaggagePrice: getCabinLuggageTotalPrice(state),
		cabinBaggageDetails: getFlightOptionsOfSelectedFlight(state)?.flightBagageOption
			?.cabinBaggage?.details,
		isCheckedBaggageIncluded: getFlightOptionsOfSelectedFlight(state)?.flightBagageOption
			?.included,
		checkedBaggageQuantity:
			state?.booking?.luggage?.quantity ||
			getFlightOptionsOfSelectedFlight(state)?.flightBagageOption?.quantity,
		checkedBaggagePrice: getLuggageTotalPrice(state),
		checkedBaggageMaxWeight:
			state?.booking?.luggage?.maxWeightPerBaggage ||
			getFlightOptionsOfSelectedFlight(state)?.flightBagageOption?.maxWeightPerBaggage,
		isSelectedTransportTrain: getSelectedTransportType(state) === TRANSPORTATION_TYPES.TRAIN,
		isCheckedBaggageOffered: getCurrentLuggageOption(state)?.pricePerBooking === 0,
	};
};

export default connect(mapStateToProps)(BaggageInfoContainer);
